export default {
    label: {
        on: 'Unsubscribe',
        off: 'Subscribe'
    },
    success: {
        on: 'E-mail notifications were successfully activated',
        off: 'E-mail notifications were successfully deactivated'
    },
    description: {
        on: 'Disable e-mail notification',
        off: 'Receive weekly e-mail updates on new content'
    }
}
